/**
 * roleHome — maps a user's roles array to the post-login landing path.
 *
 * Role priority: admin > tutor > parent (catch-all)
 *
 * @param {Object} user - User object from AuthContext
 * @param {Array<string>} user.roles - Array of role name strings
 * @returns {string} Landing path for this user
 */
export function roleHome(user) {
  const roles = Array.isArray(user?.roles) ? user.roles : [];

  if (roles.includes('admin')) {
    return '/app/admin/verifications';
  }

  if (roles.includes('tutor')) {
    return '/app/tuteur/notes';
  }

  // Default: parent legacy dashboard
  return '/dashboard';
}

export default roleHome;
